import React from 'react'
import ResetPasswordRequestForm from '../../../features/user/components/ResetPasswordRequestForm/ResetPasswordRequestForm'
import PageLayout from '../../../components/organismes/PageLayout/PageLayout'

export default function ResetPasswordrequestPage() {
  return (
    <PageLayout>
      <ResetPasswordRequestForm />
    </PageLayout>
  )
}
